import Vue from 'vue'
import HTTP from '@/http-common.js'

const state = {
  list: [],
  current: [],
}

const mutations = {
  setWebsites(state, websites) {
    // Loads all websites
    state.list = websites
  },
  setSingleWebsite(state, { item }) {
    // Updates website info when editing any website from the Websites menu
    const index = state.list.findIndex((x) => x.id === item.id)
    // Check if new website has been created. If yes, push the new site to the bottom of the list
    if (index === -1) {
      state.list.push(item)
      return false
    }

    // Update existing site
    Vue.set(state.list, index, item)
  },
  setCurrent(state, { item }) {
    state.current = item
  },
}

const actions = {
  loadWebsites({ commit }) {
    return new Promise((resolve, reject) => {
      HTTP.get(`websites`).then(
        (response) => {
          resolve(commit('setWebsites', response.data))
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateWebsite({ commit }, { item }) {
    commit('setSingleWebsite', { item })
  },
  getCurrentWebsite({ commit }, { item }) {
    commit('setCurrent', { item })
  },
}

export default {
  state,
  actions,
  mutations,
}
